module.exports = __webpack_public_path__ + "static/media/79.e8140a4c.jpg";